import { gql } from 'react-apollo';

export const getMembersStatistics = gql`
  query getChurchGroupDailyMembersStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            members {
              total
              joined: joined_for_period
            }
          }
        }
      }
    }
  }
`;

export const getPointsEarnedStatistics = gql`
  query getChurchGroupDailyPointsEarnedStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            totalPointsEarned: total_points_earned {
              totalPointsEarned: total_points_earned
              delta
            }
          }
        }
      }
    }
  }
`;

export const getOvercomingStatistics = gql`
  query getChurchGroupDailyOvercomingStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            overcomingRecordsSubmitted: overcoming_records_submitted
          }
        }
      }
    }
  }
`;

export const getFastingStatistics = gql`
  query getChurchGroupDailyFastingStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            fasting {
              full
              forMeal: for_meal
              membersCount: members_count
            }
          }
        }
      }
    }
  }
`;

export const getGuestCardsActivitiesStatistics = gql`
  query getChurchGroupDailyGuestCardsActivitiesStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            guestCardActivities: guest_card_activities {
              guestsTotal: guests_total,
              guestsForPeriod: guests_for_period,
              iaksSubmitted: iaks_submitted,
              iaksSubmittedDelta: iaks_submitted_delta,
              iaksByTypeDistribution: iaks_by_type_distribution {
                iak {
                  name
                }
                count
              }
            }
          }
        }
      }
    }
  }
`;

export const getPrayingStatistics = gql`
  query getChurchGroupDailyPrayingStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            praying {
              timePrayed: time_prayed
              timePrayedDelta: time_prayed_delta
              timeDistribution: time_distribution {
                intervalStart: interval_start
                timePrayed: time_prayed
              }
            }
          }
        }
      }
    }
  }
`;

export const getGoalsAndAveragesStatistics = gql`
  query getChurchGroupDailyGoalsAndAveragesStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            goalsAndAverages: goals_and_averages {
              pointsAverage: points_average
              timePrayedAverage: time_prayed_average
              iaksAverage: iaks_average
              pointsGoalPercentage: points_goal_percentage
              timePrayedGoalPercentage: time_prayed_goal_percentage
              iaksGoalPercentage: iaks_goal_percentage
            }
          }
        }
      }
    }
  }
`;

export const getGroupPerformanceStatistics = gql`
  query getChurchGroupDailyGroupPerformanceStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          daily(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            groupPerformance: group_performance {
              position
              topPerformers: top_performers {
                position
                members {
                  id
                  name
                  photo {
                    small
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/daily/queries/queries.js